<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
  @for (paragraph of paragraphs; track $index) {
    <p>{{ paragraph }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (!data.hideCancel) {
    <button mat-stroked-button [mat-dialog-close]="false">{{ cancelLabel }}</button>
  }
  <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ confirmLabel }}</button>
</mat-dialog-actions>
